export default __webpack_public_path__ + "static/media/eventifyTwitter-600x314.49ef3456.jpg";